module.exports = __webpack_public_path__ + "img/JS.cae7927f.png";